
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-tooth-line',
      title: 'Dental Implants',
      description: 'Permanent tooth replacement solutions that look, feel, and function like natural teeth.',
      image: 'https://readdy.ai/api/search-image?query=Dental%20implant%20procedure%2C%20titanium%20implant%2C%20artificial%20tooth%20root%2C%20modern%20dental%20technology%2C%20professional%20dental%20treatment%2C%20clean%20medical%20environment&width=400&height=300&seq=dental-implants&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Root Canal Treatment',
      description: 'Pain-free endodontic therapy to save infected teeth and preserve your natural smile.',
      image: 'https://readdy.ai/api/search-image?query=Root%20canal%20treatment%2C%20endodontic%20procedure%2C%20dental%20microscope%2C%20tooth%20restoration%2C%20professional%20dental%20care%2C%20sterile%20medical%20environment&width=400&height=300&seq=root-canal&orientation=landscape'
    },
    {
      icon: 'ri-star-line',
      title: 'Cosmetic Dentistry',
      description: 'Transform your smile with veneers, whitening, and aesthetic dental treatments.',
      image: 'https://readdy.ai/api/search-image?query=Cosmetic%20dentistry%2C%20dental%20veneers%2C%20teeth%20whitening%2C%20smile%20makeover%2C%20beautiful%20white%20teeth%2C%20aesthetic%20dental%20treatment&width=400&height=300&seq=cosmetic-dentistry&orientation=landscape'
    },
    {
      icon: 'ri-align-center',
      title: 'Orthodontics',
      description: 'Straighten teeth with braces and clear aligners for a perfect, confident smile.',
      image: 'https://readdy.ai/api/search-image?query=Orthodontic%20treatment%2C%20dental%20braces%2C%20clear%20aligners%2C%20teeth%20straightening%2C%20orthodontic%20appliances%2C%20dental%20alignment%20therapy&width=400&height=300&seq=orthodontics&orientation=landscape'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Pediatric Dentistry',
      description: 'Specialized dental care for children in a friendly, comfortable environment.',
      image: 'https://readdy.ai/api/search-image?query=Pediatric%20dentistry%2C%20child%20dental%20care%2C%20kid-friendly%20dental%20office%2C%20children%20dental%20treatment%2C%20colorful%20dental%20clinic%20for%20kids&width=400&height=300&seq=pediatric-dentistry&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Teeth Whitening',
      description: 'Professional whitening treatments for a brighter, more radiant smile.',
      image: 'https://readdy.ai/api/search-image?query=Teeth%20whitening%20treatment%2C%20professional%20dental%20bleaching%2C%20bright%20white%20smile%2C%20cosmetic%20dental%20procedure%2C%20dental%20whitening%20equipment&width=400&height=300&seq=teeth-whitening&orientation=landscape'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Our Dental Services</h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive dental care tailored to your unique needs. From routine check-ups to advanced treatments, 
            we provide exceptional oral healthcare for the whole family.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              <div className="relative h-40 sm:h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-white text-lg sm:text-xl`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">{service.description}</p>
                <Link to="/services">
                  <Button variant="outline" size="sm" className="w-full">
                    Learn More
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/services">
            <Button size="lg" variant="primary" className="w-full sm:w-auto">
              View All Services
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
